module.exports = __webpack_public_path__ + "img/weddings_06_V.7d4b378e.webp";